(function () {
  var PAGE_CLASS = 'opendots2-pink-preheat--tab-stuck';
  var mqMobile = window.matchMedia('(max-width: 768px)');

  function headerEl() {
    return document.querySelector('.site-header');
  }

  function headerOffset() {
    var header = headerEl();
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  // After a section jump the announcement has scrolled away and .site-header
  // sits at top:0. Use its own height, not getBoundingClientRect().bottom —
  // at scrollTop=0 that bottom still includes the announcement (~58px on m).
  function headerHeight() {
    var header = headerEl();
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().height));
  }

  function tabHeight(bar) {
    return bar ? bar.getBoundingClientRect().height : 0;
  }

  function scrollToTarget(selector, bar) {
    var el = document.querySelector(selector);
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerHeight() - tabHeight(bar);
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function initNav(nav) {
    var bar = nav.querySelector('[data-pink-preheat-tabs]');
    var filler = nav.querySelector('[data-pink-preheat-tabs-filler]');
    var tabs = Array.prototype.slice.call(nav.querySelectorAll('[data-pink-preheat-tab]'));
    if (!bar || !tabs.length) return;

    var targets = tabs
      .map(function (tab) {
        var selector = tab.getAttribute('data-target');
        var el = selector ? document.querySelector(selector) : null;
        return el ? { tab: tab, el: el } : null;
      })
      .filter(Boolean);

    function setStuck(stuck) {
      var offset = headerOffset();
      document.body.classList.toggle(PAGE_CLASS, stuck);
      bar.classList.toggle('is-stuck', stuck);
      bar.style.top = stuck ? offset + 'px' : '';
      if (filler) {
        filler.style.height = stuck ? tabHeight(bar) + 'px' : '0px';
      }
    }

    function onScroll() {
      var offset = headerOffset();
      var navTop = nav.getBoundingClientRect().top;
      setStuck(navTop <= offset);

      if (!targets.length) return;
      var probe = window.pageYOffset + offset + tabHeight(bar) + 24;
      var active = targets[0];
      targets.forEach(function (item) {
        var top = item.el.getBoundingClientRect().top + window.pageYOffset;
        if (probe >= top) active = item;
      });
      targets.forEach(function (item) {
        var isActive = item === active;
        item.tab.classList.toggle('is-active', isActive);
        if (isActive) {
          item.tab.setAttribute('aria-current', 'true');
        } else {
          item.tab.removeAttribute('aria-current');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        var selector = tab.getAttribute('data-target');
        if (!selector) return;
        event.preventDefault();
        scrollToTarget(selector, bar);
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function initAnchorButtons(bar) {
    var buttons = document.querySelectorAll('[data-pink-preheat-scroll]');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function (event) {
        var selector = btn.getAttribute('data-pink-preheat-scroll');
        if (!selector) return;
        event.preventDefault();
        scrollToTarget(selector, bar);
      });
    });
  }

  function initGiftboxGallery(section) {
    var viewport = section.querySelector('[data-giftbox-viewport]');
    var track = section.querySelector('[data-giftbox-track]');
    var slides = section.querySelectorAll('[data-giftbox-slide]');
    var prev = section.querySelector('[data-giftbox-prev]');
    var next = section.querySelector('[data-giftbox-next]');
    if (!viewport || !track || slides.length < 2) return;

    var index = 0;

    function update() {
      var enabled = mqMobile.matches;
      track.style.transform = enabled ? 'translateX(' + -index * 100 + '%)' : '';
      if (prev) prev.disabled = !enabled || index <= 0;
      if (next) next.disabled = !enabled || index >= slides.length - 1;
      Array.prototype.forEach.call(slides, function (slide, i) {
        slide.setAttribute('aria-hidden', enabled && i !== index ? 'true' : 'false');
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        if (index > 0) {
          index -= 1;
          update();
        }
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        if (index < slides.length - 1) {
          index += 1;
          update();
        }
      });
    }

    if (typeof mqMobile.addEventListener === 'function') {
      mqMobile.addEventListener('change', update);
    } else if (typeof mqMobile.addListener === 'function') {
      mqMobile.addListener(update);
    }
    update();
  }

  function initCards(section) {
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-pink-preheat-card]'));
    if (!cards.length) return;

    var triggerEl = section.closest('.shopify-section') || section;
    var played = false;
    var finished = false;
    var duration = 2500;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var inEditor = typeof Shopify !== 'undefined' && Shopify.designMode;

    function finish() {
      if (finished) return;
      finished = true;
      section.classList.add('is-complete');
    }

    function play() {
      if (played) return;
      played = true;
      if (reduceMotion.matches || inEditor) {
        finish();
        return;
      }
      section.classList.add('is-playing');
      var lastCard = section.querySelector('.opendots2-pink-preheat-cards__card--1') || cards[cards.length - 1];
      if (lastCard) {
        lastCard.addEventListener('animationend', function onEnd(event) {
          if (event.target !== lastCard) return;
          lastCard.removeEventListener('animationend', onEnd);
          finish();
        });
      }
      window.setTimeout(finish, duration + 80);
    }

    function stickyTop() {
      var offset = headerOffset();
      var bar = document.querySelector('[data-pink-preheat-tabs]');
      if (bar && bar.classList.contains('is-stuck')) {
        offset += tabHeight(bar);
      }
      return offset;
    }

    function onScroll() {
      if (played) return;
      var rect = triggerEl.getBoundingClientRect();
      var viewMid = (stickyTop() + window.innerHeight) / 2;
      var sectionMid = rect.top + rect.height / 2;
      if (sectionMid <= viewMid) play();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (typeof mqMobile.addEventListener === 'function') {
      mqMobile.addEventListener('change', function () {
        if (played && section.classList.contains('is-playing')) finish();
      });
    } else if (typeof mqMobile.addListener === 'function') {
      mqMobile.addListener(function () {
        if (played && section.classList.contains('is-playing')) finish();
      });
    }
    onScroll();
  }

  function emailLooksValid(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value || '');
  }

  var SUBSCRIBE_MODULE = 'opendots2_pink_subscription';
  var subscribeTrackers = {};

  function pushGa4(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: params || {}
    });
  }

  function pushSubscribeGa4(email, status, contentName) {
    pushGa4('subscribe', {
      module: SUBSCRIBE_MODULE,
      status: status,
      email: email || '',
      content_name: contentName || ''
    });
  }

  function getSubscribeTracker(key) {
    if (!subscribeTrackers[key]) {
      subscribeTrackers[key] = { token: 0, fired: false, email: '' };
    }
    return subscribeTrackers[key];
  }

  function fireSubscribe(key, status, email, contentName) {
    var tracker = getSubscribeTracker(key);
    if (tracker.fired) return;
    tracker.fired = true;
    pushSubscribeGa4(email || tracker.email || '', status, contentName);
  }

  function observeModuleBottom(el, moduleName) {
    if (!el || el.getAttribute('data-pink-preheat-impression-ready') === 'true') return;
    el.setAttribute('data-pink-preheat-impression-ready', 'true');
    var fired = false;

    function check() {
      if (fired) return;
      var rect = el.getBoundingClientRect();
      if (rect.bottom <= window.innerHeight) {
        fired = true;
        window.removeEventListener('scroll', check);
        window.removeEventListener('resize', check);
        pushGa4('module_impression', { module: moduleName });
      }
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function bindKlaviyoSubscribeClick(section, formId, contentName) {
    var root = section.querySelector('[data-pink-preheat-klaviyo]');
    if (!root || !formId) return;

    var key = formId;
    var boundAttr = 'data-pink-preheat-subscribe-bound';

    function bindButton() {
      if (root.getAttribute(boundAttr) === 'true') return;
      var btn = root.querySelector('[data-testid="form-row"]:first-of-type button');
      if (!btn) return;
      root.setAttribute(boundAttr, 'true');
      btn.addEventListener('click', function () {
        var input = root.querySelector('[data-testid="form-row"]:first-of-type input');
        var tracker = getSubscribeTracker(key);
        tracker.email = input && input.value ? input.value.trim() : '';
        tracker.fired = false;
        tracker.token += 1;
        var token = tracker.token;
        window.setTimeout(function () {
          if (tracker.token !== token || tracker.fired || section.classList.contains('is-success')) return;
          if (klaviyoLooksLikeError(root)) {
            fireSubscribe(key, 'fail', tracker.email, contentName);
            return;
          }
          if (klaviyoLooksLikeThankYou(root)) {
            fireSubscribe(key, 'success', tracker.email, contentName);
            section.dispatchEvent(
              new CustomEvent('pink-preheat-klaviyo-submit', {
                detail: { metaData: { $email: tracker.email } }
              })
            );
            return;
          }
          fireSubscribe(key, 'fail', tracker.email, contentName);
        }, 4000);
      });
    }

    bindButton();
    var observer = new MutationObserver(function () {
      if (section.classList.contains('is-success')) {
        observer.disconnect();
        return;
      }
      bindButton();
    });
    observer.observe(root, { childList: true, subtree: true });
    section.addEventListener('pink-preheat-success', function () {
      observer.disconnect();
    });
  }

  function hideConsentTip(tip) {
    if (!tip) return;
    tip.hidden = true;
    tip.classList.remove('is-open', 'is-below');
  }

  function showConsentTip(wrap, tip, anchor) {
    if (!wrap || !tip || !anchor) return;
    tip.hidden = false;
    tip.classList.add('is-open');
    tip.classList.remove('is-below');
    var wrapRect = wrap.getBoundingClientRect();
    var rect = anchor.getBoundingClientRect();
    var gap = 8;
    var top = rect.bottom - wrapRect.top + gap;
    var left = rect.left - wrapRect.left;
    var maxLeft = wrapRect.width - Math.min(tip.offsetWidth || 240, wrapRect.width - 16) - 8;
    if (left > maxLeft) left = Math.max(8, maxLeft);
    if (left < 8) left = 8;
    tip.style.top = top + 'px';
    tip.style.left = left + 'px';
    var arrow = rect.left + Math.min(rect.width, 24) / 2 - wrapRect.left - left;
    tip.style.setProperty('--tip-arrow', Math.max(12, Math.min((tip.offsetWidth || 240) - 12, arrow)) + 'px');
  }

  function bindKlaviyoConsentLock(section) {
    var root = section.querySelector('[data-pink-preheat-klaviyo]');
    if (!root || root.getAttribute('data-pink-preheat-consent-lock') === 'true') return;
    root.setAttribute('data-pink-preheat-consent-lock', 'true');

    var wrap = section.querySelector('[data-pink-preheat-form-wrap]');
    var tip = section.querySelector('[data-pink-preheat-consent-tip]');
    var listening = false;
    var debounceTimer;

    function getForm() {
      return root.querySelector('form');
    }

    function getSubmit(form) {
      var row = form.querySelector('[data-testid="form-row"]');
      return (
        (row && row.querySelector('button')) ||
        form.querySelector('button[type="submit"]') ||
        form.querySelector('button')
      );
    }

    function getBoxes(form) {
      return form.querySelectorAll('input[type="checkbox"], [role="checkbox"]');
    }

    function isChecked(el) {
      if (el.type === 'checkbox') return !!el.checked;
      return el.getAttribute('aria-checked') === 'true';
    }

    function allConsentChecked(form) {
      var boxes = getBoxes(form);
      if (!boxes.length) return false;
      for (var i = 0; i < boxes.length; i += 1) {
        if (!isChecked(boxes[i])) return false;
      }
      return true;
    }

    function setLocked(btn, locked) {
      if (!btn) return;
      btn.classList.toggle('is-disabled', locked);
      if (locked) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    }

    function sync() {
      if (section.classList.contains('is-success')) {
        hideConsentTip(tip);
        return;
      }
      var form = getForm();
      if (!form) return;
      var btn = getSubmit(form);
      if (btn) setLocked(btn, !allConsentChecked(form));
      if (allConsentChecked(form)) {
        hideConsentTip(tip);
        return;
      }
      window.requestAnimationFrame(function () {
        showTip();
      });
    }

    function firstUnchecked(form) {
      var boxes = getBoxes(form);
      for (var i = 0; i < boxes.length; i += 1) {
        if (!isChecked(boxes[i])) {
          return boxes[i].closest('[data-testid="form-row"]') || boxes[i];
        }
      }
      return null;
    }

    function showTip() {
      var form = getForm();
      if (!form) return;
      showConsentTip(wrap, tip, firstUnchecked(form));
    }

    function onConsentChange() {
      sync();
    }

    function blockIfLocked(event) {
      var form = getForm();
      if (!form) return;
      var btn = getSubmit(form);
      if (!btn || !btn.classList.contains('is-disabled')) return;
      if (event.type === 'click' && !btn.contains(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showTip();
    }

    function paintConsent(form) {
      if (section.classList.contains('is-success')) return;
      var rows = form.querySelectorAll('[data-testid="form-row"]');
      var fontSize = mqMobile.matches ? '12px' : '14px';
      var lineHeight = mqMobile.matches ? '18px' : '23px';
      Array.prototype.forEach.call(rows, function (row) {
        if (row.querySelector('input[type="email"]') || row.querySelector('button')) return;
        var nodes = row.querySelectorAll('div, span, p, a, label, li');
        Array.prototype.forEach.call(nodes, function (el) {
          el.style.setProperty('color', '#616267', 'important');
          el.style.setProperty('-webkit-text-fill-color', '#616267', 'important');
          el.style.setProperty('font-size', fontSize, 'important');
          el.style.setProperty('font-weight', '400', 'important');
          el.style.setProperty('line-height', lineHeight, 'important');
        });
      });
    }

    function attach() {
      var form = getForm();
      if (!form) return;
      if (!listening) {
        listening = true;
        form.addEventListener('change', onConsentChange, true);
        form.addEventListener('click', onConsentChange, true);
        form.addEventListener('click', blockIfLocked, true);
        form.addEventListener('submit', blockIfLocked, true);
      }
      paintConsent(form);
      sync();
    }

    attach();
    var observer = new MutationObserver(function () {
      if (section.classList.contains('is-success')) {
        observer.disconnect();
        hideConsentTip(tip);
        return;
      }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(attach, 80);
    });
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked', 'aria-checked']
    });
    section.addEventListener('pink-preheat-success', function () {
      observer.disconnect();
      hideConsentTip(tip);
    });
  }

  function klaviyoCopy(root) {
    return ((root && (root.innerText || root.textContent)) || '').replace(/\s+/g, ' ');
  }

  function klaviyoLooksLikeThankYou(root) {
    return /ขอบคุณที่ลงทะเบียน/i.test(klaviyoCopy(root));
  }

  function klaviyoLooksLikeError(root) {
    return !!(root && root.querySelector('[aria-invalid="true"]'));
  }

  function bindKlaviyoForms() {
    if (window.__opendots2PinkPreheatKlaviyo) return;
    window.__opendots2PinkPreheatKlaviyo = true;
    window.addEventListener('klaviyoForms', function (e) {
      if (!e.detail || !e.detail.formId) return;
      if (e.detail.type !== 'submit') return;
      var formId = String(e.detail.formId).replace(/^klaviyo-form-/i, '').trim();
      var sections = document.querySelectorAll('[data-pink-preheat-list]');
      Array.prototype.forEach.call(sections, function (section) {
        var sectionFormId = (section.getAttribute('data-klaviyo-form-id') || '').replace(/^klaviyo-form-/i, '').trim();
        if (sectionFormId !== formId) return;
        var email =
          e.detail.metaData && e.detail.metaData.$email ? e.detail.metaData.$email : '';
        var contentName = section.getAttribute('data-ga-content-name') || '';
        var root = section.querySelector('[data-pink-preheat-klaviyo]');
        window.setTimeout(function () {
          if (section.classList.contains('is-success')) return;
          if (klaviyoLooksLikeError(root)) {
            fireSubscribe(formId, 'fail', email, contentName);
            return;
          }
          fireSubscribe(formId, 'success', email, contentName);
          section.dispatchEvent(
            new CustomEvent('pink-preheat-klaviyo-submit', { detail: e.detail })
          );
        }, 120);
      });
    });
    document.addEventListener('click', function (event) {
      var close = event.target.closest('[data-pink-preheat-modal-close]');
      if (!close) return;
      var dialog = close.closest('[data-pink-preheat-modal]');
      if (!dialog || !dialog.classList.contains('is-open')) return;
      var list =
        dialog.closest('[data-pink-preheat-list]') ||
        document.querySelector('[data-pink-preheat-list].is-success') ||
        document.querySelector('[data-pink-preheat-list]');
      if (list) list.dispatchEvent(new CustomEvent('pink-preheat-modal-close'));
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openDialog = document.querySelector('[data-pink-preheat-modal].is-open');
      if (!openDialog) return;
      var list =
        openDialog.closest('[data-pink-preheat-list]') ||
        document.querySelector('[data-pink-preheat-list]');
      if (list) list.dispatchEvent(new CustomEvent('pink-preheat-modal-close'));
    });
  }

  function initList(section) {
    var formId = (section.getAttribute('data-klaviyo-form-id') || '').trim();
    var live = section.querySelector('[data-pink-preheat-live]');
    var success = section.querySelector('[data-pink-preheat-success]');
    var modal = section.querySelector('[data-pink-preheat-modal]');
    var form = section.querySelector('[data-pink-preheat-form]');
    var consent = section.querySelector('[data-pink-preheat-consent]');
    var submit = section.querySelector('.opendots2-pink-preheat-list__submit');
    var inEditor = typeof Shopify !== 'undefined' && Shopify.designMode;
    var storageKey = formId ? 'opendots2-pink-preheat-list:' + formId : '';
    var contentName = section.getAttribute('data-ga-content-name') || '';
    var subscribeKey = formId || 'pink-preheat-native';
    var submitted = false;
    var lastFocus = null;
    var modalHome = modal ? modal.parentNode : null;

    function revealSuccess() {
      section.classList.add('is-success');
      if (live) {
        live.hidden = true;
        live.setAttribute('aria-hidden', 'true');
      }
      if (success) success.removeAttribute('hidden');
      hideConsentTip(section.querySelector('[data-pink-preheat-consent-tip]'));
      section.dispatchEvent(new CustomEvent('pink-preheat-success'));
    }

    function openModal() {
      if (!modal) return;
      lastFocus = document.activeElement;
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
      modal.hidden = false;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var btn = modal.querySelector('.opendots2-pink-preheat-list__modal-btn');
      if (btn) btn.focus();
    }

    function closeModal() {
      if (!modal || !modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
      document.body.style.overflow = '';
      if (modalHome && modal.parentNode !== modalHome) {
        modalHome.appendChild(modal);
      }
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function markSubmitted(email, showModal) {
      if (submitted) return;
      submitted = true;
      if (storageKey && !inEditor) {
        try {
          sessionStorage.setItem(storageKey, '1');
        } catch (err) {}
      }
      hideConsentTip(section.querySelector('[data-pink-preheat-consent-tip]'));
      revealSuccess();
      if (showModal) openModal();
    }

    if (storageKey && !inEditor) {
      try {
        if (sessionStorage.getItem(storageKey) === '1') {
          submitted = true;
          revealSuccess();
        }
      } catch (err) {}
    }

    bindKlaviyoSubscribeClick(section, formId, contentName);
    bindKlaviyoConsentLock(section);

    (function watchKlaviyoSuccess() {
      var root = section.querySelector('[data-pink-preheat-klaviyo]');
      if (!root) return;
      var debounceTimer;
      var observer;
      function check() {
        if (submitted) {
          if (observer) observer.disconnect();
          return;
        }
        if (klaviyoLooksLikeError(root) || !klaviyoLooksLikeThankYou(root)) return;
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(function () {
          if (submitted || klaviyoLooksLikeError(root) || !klaviyoLooksLikeThankYou(root)) return;
          markSubmitted('', true);
        }, 80);
      }
      check();
      observer = new MutationObserver(check);
      observer.observe(root, { childList: true, subtree: true });
      section.addEventListener('pink-preheat-success', function () {
        window.clearTimeout(debounceTimer);
        observer.disconnect();
      });
    })();

    section.addEventListener('pink-preheat-klaviyo-submit', function (event) {
      var email =
        event.detail && event.detail.metaData && event.detail.metaData.$email
          ? event.detail.metaData.$email
          : '';
      markSubmitted(email, true);
    });
    section.addEventListener('pink-preheat-modal-close', closeModal);

    if (!form || !consent || !submit) return;

    function syncConsent() {
      var enabled = consent.checked;
      var wrap = section.querySelector('[data-pink-preheat-form-wrap]');
      var tip = section.querySelector('[data-pink-preheat-consent-tip]');
      var anchor = consent.closest('.opendots2-pink-preheat-list__consent') || consent;
      submit.disabled = false;
      submit.classList.toggle('is-disabled', !enabled);
      if (enabled) {
        submit.removeAttribute('aria-disabled');
        hideConsentTip(tip);
      } else {
        submit.setAttribute('aria-disabled', 'true');
        showConsentTip(wrap, tip, anchor);
      }
    }

    consent.addEventListener('change', syncConsent);
    submit.addEventListener('click', function (event) {
      if (consent.checked) return;
      event.preventDefault();
      showConsentTip(
        section.querySelector('[data-pink-preheat-form-wrap]'),
        section.querySelector('[data-pink-preheat-consent-tip]'),
        consent.closest('.opendots2-pink-preheat-list__consent') || consent
      );
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var email = input && input.value ? input.value.trim() : '';
      var tracker = getSubscribeTracker(subscribeKey);
      tracker.fired = false;
      tracker.email = email;
      if (!consent.checked || !emailLooksValid(email)) {
        if (!consent.checked) {
          showConsentTip(
            section.querySelector('[data-pink-preheat-form-wrap]'),
            section.querySelector('[data-pink-preheat-consent-tip]'),
            consent.closest('.opendots2-pink-preheat-list__consent') || consent
          );
        }
        if (input && !emailLooksValid(email)) input.setAttribute('aria-invalid', 'true');
        fireSubscribe(subscribeKey, 'fail', email, contentName);
        return;
      }
      if (input) input.removeAttribute('aria-invalid');
      fireSubscribe(subscribeKey, 'success', email, contentName);
      markSubmitted(email, true);
    });
    syncConsent();
  }

  function initEvent(section) {
    var calendar = section.querySelector('[data-pink-preheat-calendar]');
    if (!calendar || calendar.getAttribute('data-pink-preheat-ga-bound') === 'true') return;
    calendar.setAttribute('data-pink-preheat-ga-bound', 'true');
    var contentName = section.getAttribute('data-ga-content-name') || '';
    var lastClick = 0;
    calendar.addEventListener('click', function () {
      var now = Date.now();
      if (now - lastClick < 400) return;
      lastClick = now;
      pushGa4('select_content', {
        content_type: 'exclusive_event',
        content_name: contentName,
        button_name: 'add_to_calendar'
      });
    });
  }

  function init() {
    var nav = document.querySelector('[data-pink-preheat-nav]');
    var bar = nav ? nav.querySelector('[data-pink-preheat-tabs]') : null;
    if (nav && !nav.getAttribute('data-pink-preheat-ready')) {
      nav.setAttribute('data-pink-preheat-ready', 'true');
      initNav(nav);
    }
    if (!document.body.getAttribute('data-pink-preheat-anchors')) {
      document.body.setAttribute('data-pink-preheat-anchors', 'true');
      initAnchorButtons(bar);
    }
    var giftbox = document.querySelector('[data-pink-preheat-giftbox]');
    if (giftbox && !giftbox.getAttribute('data-pink-preheat-ready')) {
      giftbox.setAttribute('data-pink-preheat-ready', 'true');
      initGiftboxGallery(giftbox);
    }
    var cards = document.querySelector('[data-pink-preheat-cards]');
    if (cards && !cards.getAttribute('data-pink-preheat-ready')) {
      cards.setAttribute('data-pink-preheat-ready', 'true');
      initCards(cards);
    }
    bindKlaviyoForms();
    var list = document.querySelector('[data-pink-preheat-list]');
    if (list && !list.getAttribute('data-pink-preheat-ready')) {
      list.setAttribute('data-pink-preheat-ready', 'true');
      initList(list);
    }
    if (list) observeModuleBottom(list, 'subscribe_draw');
    var eventSection = document.querySelector('[data-pink-preheat-event]');
    if (eventSection && !eventSection.getAttribute('data-pink-preheat-ready')) {
      eventSection.setAttribute('data-pink-preheat-ready', 'true');
      initEvent(eventSection);
    }
    if (eventSection) observeModuleBottom(eventSection, 'exclusive_event');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
